import { isDevelopmentEnvironment } from "@/lib/env";

// Ligado: a funcionalidade só aparece fora de produção (localhost e homologação/DEV), usando a mesma
// verificação de ambiente do resto do sistema (@/lib/env). Desligue (false) para liberar em produção.
export const NEW_ORDER_ZENDESK_TICKET_DEV_ONLY = true;

export let isNewOrderZendeskTicketEnabled = false;

// Toggle "Abrir chamado no Zendesk ao criar pedido" na tela de gerenciar cliente (profile client).
// Comente a linha abaixo para desativar a funcionalidade no frontend.
// Mantenha em sincronia com Features/NewOrderZendeskTicketFeature.cs do backend.
isNewOrderZendeskTicketEnabled = !NEW_ORDER_ZENDESK_TICKET_DEV_ONLY || isDevelopmentEnvironment;

// Exibição do card "Chamado no Zendesk ao criar pedido" na tela de gerenciar cliente (profile client).
// A área de negócio não quer ver essa seleção: desligado, a configuração é feita só pela tela de Desenvolvimento
// (Chamados no Zendesk) e a flag client.create_zendesk_ticket_on_order continua no banco. Troque para true
// para voltar a exibir o card na tela de gerenciar cliente.
export const isNewOrderZendeskTicketClientCardVisible = false;
